//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';
import DOMPurify from 'dompurify';
import { VueEditor } from 'vue2-quill-editor';

export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ header: 1 }, { header: 2 }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ direction: 'rtl' }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ['clean'],
      ],
      model: {
        groupCurrencyId: 0,
        groupMinBalance: 0,
        privateCurrencyId: 0,
        privateMinBalance: 0,
        publicCurrencyId: 0,
        publicMinBalance: 0,
        stopGroupChat: false,
        stopPrivateChat: false,
        stopPublicChat: false,
        enableGroupChatWarningMessage: false,
        clearChatStopWords: false,
        callArbitratorOnStopWords: false,
        groupChatWarningMessage: '',
        stopWordsJson: '',
      },
      isWordsEdited: false,
      loader: false,
    };
  },

  async mounted() {
    await this.loadModerationWords();
    if (localStorage.getItem('chatOptions')) {
      this.model = JSON.parse(localStorage.getItem('chatOptions'));
    }
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapState('currencies', ['currencies']),
    ...mapState('chatOptions', ['options']),
    ...mapState('login', ['currentAdmin']),
    ...mapState('p2pModerationWords', {
      moderationWords: 'data',
    }),

    isDisabled() {
      const { loader, generalLoader } = this;
      return loader || generalLoader;
    },

    hasPermission() {
      return this.currentAdmin.adminStatus === 0 || this.currentAdmin.adminStatus === 1;
    },
  },

  watch: {
    options(data) {
      if (localStorage.getItem('chatOptions')) {
        const chatOptionsRaw = localStorage.getItem('chatOptions');
        if (chatOptionsRaw) {
          const chatOptions = JSON.parse(chatOptionsRaw);
          const isEqual = JSON.stringify(data) === chatOptionsRaw;

          if (!isEqual) {
            this.model = chatOptions;
          } else {
            this.model = data;
          }
        }
      } else {
        this.model = data;
      }
    },
    model: {
      handler(data) {
        localStorage.setItem('chatOptions', JSON.stringify(data));
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('chatOptions', ['updateChatOptions']),
    ...mapActions('p2pModerationWords', {
      loadModerationWords: 'loadData',
    }),

    sanitize(text) {
      return DOMPurify.sanitize(text, { USE_PROFILES: { html: true } });
    },

    async apply() {
      this.model.groupChatWarningMessage = this.sanitize(this.model.groupChatWarningMessage);

      const { model } = this;

      const words = [];
      this.moderationWords.forEach((e) => {
        words.push(...e.words.trim().split(','));
      });

      this.model.stopWordsJson = JSON.stringify(words.map((e) => e.trim()));

      this.loader = true;
      this.setGeneralProgress(true);
      try {
        await this.updateChatOptions(model);
        this.setSuccessNotification('Changes saved');
      } catch (error) {
        this.setErrorNotification(error.message);
      } finally {
        this.loader = false;
        this.setGeneralProgress(false);
        localStorage.removeItem('chatOptions');
      }
    },
  },
};
